import { Component } from '@angular/core';
import { WhatsappForBusinessService } from '../../../../services/whatsapp-for-business.service';
import { FacebookSdkService } from '../../../../services/facebook-sdk.service';
import { HelpersService } from '../../../../services/helpers.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-whatsapp-integration',
  templateUrl: './whatsapp-integration.component.html',
  styleUrls: ['./whatsapp-integration.component.scss']
})
export class WhatsappIntegrationComponent {

  public busy: boolean = false;
  public savingNumber: boolean = false;
  public disconnecting: boolean = false;
  public linkedToWhatsApp: boolean = false;
  public hasPhoneNumber: boolean = false;
  public storeConfig: any = null;
  public appID: string = null;
  public configID: string = null;
  public phoneNumbers: any = [];
  public hasWhatsappSubscription: boolean = false;
  public isWorkshop = true;
  public isRentals = false;

  constructor(
    private whatsappForBusinessService: WhatsappForBusinessService,
    private facebookSdkService: FacebookSdkService,
    private helpersService: HelpersService,
    private router: Router
  ) {

  }

  ngOnInit() {
    if (
      this.router.url.toLocaleLowerCase() ===
      '/store/rentals/whatsapp-integration'
    ) {
      this.isRentals = true;
      this.isWorkshop = false;
    }
    this.getWhatsappConfig();

  }

  getWhatsappConfig(busy = true) {
    this.busy = busy;
    this.hasPhoneNumber = false;
    this.whatsappForBusinessService.getWhatsAppConfiguration(this.helpersService.getPartnerId()).subscribe(res => {
      this.hasWhatsappSubscription = res.hasWhatsappSubscription;
      if (this.hasWhatsappSubscription) {
        this.storeConfig = res.storeConfig;
        if (res && res.keys && res.keys.whatsAppID && res.keys.whatsAppConfigID && !this.storeConfig.hasToken) {
          this.appID = res.keys.whatsAppID;
          this.configID = res.keys.whatsAppConfigID;
          this.facebookSdkService.loadSdk(this.appID);
        }
        if (res && res.storeConfig && res.storeConfig.phoneID) {
          this.hasPhoneNumber = true;
        }
        this.checkIfLinkedToWhatsapp();
        this.busy = false;
        this.savingNumber = false;
      } else {
        this.busy = false;
      }
    }, err => {
      this.busy = false;
    })
  }

  checkIfLinkedToWhatsapp() {
    if (this.storeConfig && this.storeConfig.hasToken) {
      this.linkedToWhatsApp = true;
      this.getWhatsappPhoneNumbers();
    } else {
      this.linkedToWhatsApp = false;
    }
  }

  getWhatsappPhoneNumbers() {
    this.whatsappForBusinessService.getWhatsAppPhoneNumbers(this.helpersService.getPartnerId()).subscribe(phoneNumbers => {
      this.phoneNumbers = phoneNumbers.data;
    });
  }


  connectWhatsapp() {
    if (this.configID) {
      this.busy = true;
      this.facebookSdkService.launchWhatsAppSignup(this.configID).subscribe(code => {
        console.log(code);
        if (code) {
          this.whatsappForBusinessService.completeWhatsAppOAuth(this.helpersService.getPartnerId(), code).subscribe(res => {
            console.log(res);
            this.busy = false;
            this.storeConfig = res.storeConfig;;
            this.checkIfLinkedToWhatsapp();
          }, err => {
            this.busy = false;

          })
        }

      }, err => {
        console.log(err);
        this.busy = false;
      });
    }
  }

  disconnectWhatsapp() {

    this.disconnecting = true;
    this.whatsappForBusinessService.disconnectWhatsApp(this.helpersService.getPartnerId()).subscribe(res => {
      this.getWhatsappConfig();
      this.disconnecting = false;
    },err=>{
      this.disconnecting = false;
      this.getWhatsappConfig();
    });

  }

  savePhoneNumber() {
    this.savingNumber = true;
    this.whatsappForBusinessService.updateWhatsAppPhoneID(this.helpersService.getPartnerId(), this.storeConfig.phoneID, "").subscribe(res => {
      this.getWhatsappConfig(false);
    }, err => {
      this.storeConfig.phoneID = null;
      this.savingNumber = false;
    });
  }

}
